(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["athlete-grid"] && !window.DesignMode) return;
  try {
    
  
  
  document.getElementById('showAllButton').addEventListener('click', function() {
    var additionalItems = document.getElementById('additionalItems');
    
    if (additionalItems.classList.contains('show')) {
      // Start der Animation zum Verstecken
      additionalItems.classList.remove('show');
      // Warten auf das Ende der Animation, bevor display:none gesetzt wird
      setTimeout(() => {
        additionalItems.style.display = 'none';
      }, 500); // Warten auf das Ende der CSS-Transition
      this.textContent = 'Alle Athleten anzeigen';
    } else {
      // display:block setzen, bevor die Animation beginnt
      additionalItems.style.display = 'block';
      // Ein kleiner Timeout, um der 'display'-Eigenschaft Zeit zu geben, angewendet zu werden
      setTimeout(() => {
        additionalItems.classList.add('show');
      }, 10);
      this.textContent = 'Weniger anzeigen';
    }
  });
  
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["athlete"]) return;
  try {
    


document.getElementById('showAllButton').addEventListener('click', function() {
  var additionalItems = document.getElementById('additionalItems');
  
  if (additionalItems.classList.contains('show')) {
    // Start der Animation zum Verstecken
    additionalItems.classList.remove('show');
    // Warten auf das Ende der Animation, bevor display:none gesetzt wird
    setTimeout(() => {
      additionalItems.style.display = 'none';
    }, 500); // Warten auf das Ende der CSS-Transition
    this.textContent = 'Alle Athleten anzeigen';
  } else {
    // display:block setzen, bevor die Animation beginnt
    additionalItems.style.display = 'block';
    // Ein kleiner Timeout, um der 'display'-Eigenschaft Zeit zu geben, angewendet zu werden
    setTimeout(() => {
      additionalItems.classList.add('show');
    }, 10);
    this.textContent = 'Weniger anzeigen';
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-json-faq"] && !window.DesignMode) return;
  try {
    
(function initFAQ() {
    const toggleQuestion = (event) => {
        var x = event.target.parentElement.parentElement.getAttribute("aria-expanded"); 
        if (x == "true") {
            x = "false"
        } else {
            x = "true"
        }
        event.target.parentElement.parentElement.setAttribute("aria-expanded", x);
        event.target.parentElement.parentElement.nextElementSibling.classList.toggle("close");
    }
    const faqNodes = document.querySelectorAll('.faq-section h3');
    for (let i = 0; i < faqNodes.length; i++) {
        faqNodes[i].addEventListener("click", toggleQuestion);
    }   
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-usps"]) return;
  try {
    
    (function initUSPs() {
        const uspElement =  document.querySelector('#funkyUsps');
        if(uspElement != null) {
            let currentActiveElement = 1;

            const imageNodes =  document.querySelectorAll('#funkyUsps .imageCarousel div');
            const textNodes =  document.querySelectorAll('#funkyUsps .textCarousel div');
            const headlineNodes = document.querySelectorAll('#funkyUsps .headlineCarousel div');

            const rotateContent = () => {
                for (let i = 0; i < headlineNodes.length; i++) {
                    if(headlineNodes[i].classList.contains('active')) {
                        headlineNodes[i].classList.remove("active")
                    }
                }            
                headlineNodes[currentActiveElement].classList.add("active");

                for (let i = 0; i < imageNodes.length; i++) {
                    if(imageNodes[i].classList.contains('active')) {
                        imageNodes[i].classList.remove("active")
                    }
                }             
                imageNodes[currentActiveElement].classList.add("active");


                for (let i = 0; i < textNodes.length; i++) {
                    if(textNodes[i].classList.contains('active')) {
                        textNodes[i].classList.remove("active")
                    }
                }             
                textNodes[currentActiveElement].classList.add("active");            
            }

            const backButton = document.querySelector('#funkyUsps .imageCarousel .back');
            const forwardButton = document.querySelector('#funkyUsps .imageCarousel .forward');

            const buttonClick = (event) => {
                let element = event.currentTarget;

                if (element.classList.contains('back')) {
                    currentActiveElement = (currentActiveElement + 2) % 3;
                }

                if (element.classList.contains('forward')) {
                    currentActiveElement = (currentActiveElement + 1) % 3;
                }
                                    
                rotateContent();
            }

            const toggleHeadline = (event) => {
                currentActiveElement = event.currentTarget.dataset.count;  
                rotateContent();
            }        

            for (let i = 0; i < headlineNodes.length; i++) {
                headlineNodes[i].addEventListener("click", toggleHeadline);
            }        

            backButton.addEventListener("click", buttonClick);
            forwardButton.addEventListener("click", buttonClick);
        }
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-videoask"] && !window.DesignMode) return;
  try {
    
(function initVideoask() {
  document.addEventListener('DOMContentLoaded', function() {
      var videoNudge = document.querySelector('#videoNudge');

      if (videoNudge) {
          videoNudge.addEventListener('click', function() {
              var videoaskContainer = document.querySelector('#videoaskContainer');
              if (videoaskContainer) {
                  videoaskContainer.scrollIntoView({ behavior: 'smooth' });
              }
          });

          var productGalleryViewer = document.querySelector('.product-gallery--navigation');
          if (productGalleryViewer) {
              productGalleryViewer.appendChild(videoNudge);
          } 
      }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mighty-performance-stage"]) return;
  try {
    
  (function initMightyStage() {
      const volumeButton = document.querySelector('#videoSound');
      const videoContainer = document.querySelector('#performant-video');
      const toggleAudio = (event) => {
          videoContainer.muted ? videoContainer.muted = false : videoContainer.muted = true;
          volumeButton.classList.toggle("volumenOn");
      }
      volumeButton.addEventListener("click", toggleAudio);
  
      videoContainer.addEventListener('loadeddata', function() {
          volumeButton.classList.toggle("hidden");
      });
  
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-article-calculator"]) return;
  try {
    
  (function initTOC() {
      var headers = document.querySelectorAll(".article--content h2");
      var tocContainer = document.getElementById("toc");
      headers.forEach(function(header) {
          var headerId = header.textContent.replace(/\s/g, "-").toLowerCase();
          header.id = headerId;
          var anker = document.createElement('a');
          anker.setAttribute('href', '#' + headerId);
          anker.innerText = header.textContent;
          tocContainer.appendChild(anker);
      });
      if (tocContainer.hasChildNodes()) {
        tocContainer.classList.add("styled");
      }
  })();

  (function berechneStromkosten() {
      var doCalc = document.getElementById("doCalc");
      doCalc.addEventListener("click", calc);

      function calc() {
        const strompreis = parseFloat(document.getElementById('strompreis').value);
        const akkukapazitaet = parseFloat(document.getElementById('akkukapazitaet').value);
        const reichweite = parseFloat(document.getElementById('reichweite').value);
        const fahrleistung = parseFloat(document.getElementById('fahrleistung').value);

        if (isNaN(strompreis) || isNaN(akkukapazitaet) || isNaN(reichweite) || isNaN(fahrleistung)) {
            document.getElementById('result').innerText = "Bitte alle Felder korrekt ausfüllen.";
            return;
        }

        // Akkukapazität in kWh umrechnen
        const akkukapazitaetKWh = akkukapazitaet / 1000;

        // Anzahl der vollen Akkuladungen pro Jahr berechnen
        const anzahlLadungenProJahr = fahrleistung / reichweite;

        // Stromkosten pro Jahr berechnen
        const stromkostenProJahr = anzahlLadungenProJahr * akkukapazitaetKWh * strompreis;

        document.getElementById('result').innerText = `Die jährlichen Stromkosten betragen: €${stromkostenProJahr.toFixed(2)}`;
      }
    })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-article-pct"]) return;
  try {
    
  (function initTOC() {
      var headers = document.querySelectorAll(".article--content h2");
      var tocContainer = document.getElementById("toc");
      headers.forEach(function(header) {
          var headerId = header.textContent.replace(/\s/g, "-").toLowerCase();
          header.id = headerId;
          var anker = document.createElement('a');
          anker.setAttribute('href', '#' + headerId);
          anker.innerText = header.textContent;
          tocContainer.appendChild(anker);
      });
      if (tocContainer.hasChildNodes()) {
        tocContainer.classList.add("styled");
      }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-article"]) return;
  try {
    
  (function initTOC() {
      var headers = document.querySelectorAll(".article--content h2");
      var tocContainer = document.getElementById("toc");
      headers.forEach(function(header) {
          var headerId = header.textContent.replace(/\s/g, "-").toLowerCase();
          header.id = headerId;
          var anker = document.createElement('a');
          anker.setAttribute('href', '#' + headerId);
          anker.innerText = header.textContent;
          tocContainer.appendChild(anker);
      });
      if (tocContainer.hasChildNodes()) {
        tocContainer.classList.add("styled");
      }
  })();

  (function initProgressBar() {
    const progressBar = document.getElementById('progress-bar');

    // Event-Listener für Scrollen hinzufügen
    window.addEventListener('scroll', () => {
        const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrollTop = document.documentElement.scrollTop;
        const scrollPercent = (scrollTop / scrollHeight) * 100;

        // Höhe des Fortschrittsbalkens entsprechend der Scrollposition setzen
        progressBar.style.width = `${scrollPercent}%`;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-dictionary-article"]) return;
  try {
    
  (function initTOC() {
      var headers = document.querySelectorAll(".article--content h2");
      var tocContainer = document.getElementById("toc");
      headers.forEach(function(header) {
          var headerId = header.textContent.replace(/\s/g, "-").toLowerCase();
          header.id = headerId;
          var anker = document.createElement('a');
          anker.setAttribute('href', '#' + headerId);
          anker.innerText = header.textContent;
          tocContainer.appendChild(anker);
      });
      if (tocContainer.hasChildNodes()) {
        tocContainer.classList.add("styled");
      }
  })();

  } catch(e) { console.error(e); }
})();
})();
